import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";

export default function CalendarFields({
    halfWayCount,
    setHalfWayCount,
    threeQuarterCount,
    setThreeQuarterCount,
    completeCount,
    setCompleteCount,
    completeMetricCount,
    setCompleteMetricCount,
    metricDescription,
    setMetricDescription,
}) {
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="halfWayCountControl">
                    <Form.Label>Days to show half way message</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="Leave empty if none"
                        value={halfWayCount ?? ''}
                        onChange={e => setHalfWayCount(e.target.value)}
                        name="HalfWayCount"
                    />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="ThreeQuarterCountControl">
                    <Form.Label>Days to show 75% message</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="Leave empty if none"
                        value={threeQuarterCount ?? ''}
                        onChange={e => setThreeQuarterCount(e.target.value)}
                        name="ThreeQuarterCount"
                    />
                </Form.Group>
                <Form.Group as={Col} md="4" controlId="CompleteCountControl">
                    <Form.Label>Days to show complete message</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="Leave empty if none"
                        value={completeCount ?? ''}
                        onChange={e => setCompleteCount(e.target.value)}
                        name="CompleteCount"
                    />
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="CompleteMetricCountControl">
                    <Form.Label>Completion Amount</Form.Label>
                    <Form.Control
                        type="number"
                        step="0.1"
                        placeholder="Leave empty if none"
                        value={completeMetricCount ?? ''}
                        onChange={e => setCompleteMetricCount(e.target.value)}
                        name="CompleteMetricCount"
                    />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="metricDescriptionControl">
                    <Form.Label>Metric description (e.g. miles)</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter description"
                        value={metricDescription ?? ''}
                        onChange={e => setMetricDescription(e.target.value)}
                        name="MetricDescription"
                    />
                </Form.Group>
            </Row>
        </>
    );
}
